import { TrendingUp, TrendingDown, Minus } from 'lucide-react'

/**
 * The change against the previous weighing at the kraal, as `weightDelta()` in
 * utils/presence.js shapes it: an arrow and "+12 kg". Shared by the wall tile and
 * the kraal timeline's visit cards (plan smartkraal-owner-experience B1).
 */
export default function DeltaBadge({ delta, className = '' }) {
  if (!delta) return null
  const Icon = delta.dir === 'up' ? TrendingUp : delta.dir === 'down' ? TrendingDown : Minus
  const cls = delta.dir === 'up' ? 'text-green-700' : delta.dir === 'down' ? 'text-red-700' : 'text-earth-500'
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${cls} ${className}`}
          title="Change against the previous weighing at the kraal" data-testid="weight-delta">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />{delta.text}
    </span>
  )
}
